import moment, { Moment } from 'moment'

export function timeFormatter(value: number, unit: string, suffix: string) {
  if (unit === 'second') {
    return 'A few seconds ago'
  }

  return `${value} ${unit}${value === 1 ? '' : 's'} ${suffix}`
}

export function formatTimestamp(timestamp: number | Date | Moment): string | undefined {
  if (timestamp) {
    return moment(timestamp).format('D/M/YYYY HH:mm')
  }
}
